import { cn } from '@/lib/utils'
import { memo } from 'react'

const SectionMapMarker = ({
  number,
  left,
  top,
  name,
  isCurrent
}: {
  number: number
  left: number
  top: number
  name: string
  isCurrent: boolean
}) => (
  <>
    <div
      className={cn(
        'textstyle-sm-bold pointer-events-none absolute flex size-4.5 items-center justify-center rounded-full bg-white text-neutral-600 md:size-5.5',
        'transition-all duration-300'
      )}
      style={{ left: `${left}%`, top: `${top}%` }}
      data-current={isCurrent}
    >
      <span className="relative z-2 leading-none">{number.toString()}</span>
    </div>

    <div
      className={cn(
        'absolute bottom-0 ml-2.5 w-[2px] origin-bottom bg-neutral-100',
        'transition-all duration-500',
        'scale-y-0',
        'data-[current=true]:scale-y-100',
        'data-[current=true]:delay-150'
      )}
      data-current={isCurrent}
      style={{ height: `${top + 10}%`, left: `${left}%`, top: '-10%' }}
    >
      <div
        className={cn(
          'absolute -top-1 overflow-hidden font-bold text-nowrap text-neutral-100',
          left >= 60 ? 'right-sm' : 'left-sm'
        )}
      >
        <div
          className={cn(
            'relative translate-y-full',
            'transition-all delay-500 duration-500',
            'data-[current=true]:translate-y-0'
          )}
          data-current={isCurrent}
        >
          {name}
        </div>
      </div>
    </div>
  </>
)

SectionMapMarker.displayName = 'SectionMapMarker'

export default memo(SectionMapMarker)
